import restApiDispatcher from "@/store/utils/api-dispatcher";
import { Chat, Message } from "@/models";

const getContactList = (context, params) =>
  restApiDispatcher(context, {
    resource: Chat,
    action: "getContactList",
    commitType: "contactListInfiniteScroll",
    storeKey: "contacts",
    loadingKey: "contactListLoading",
    params
  });

const getMessages = (context, params) =>
  restApiDispatcher(context, {
    resource: Message,
    action: "index",
    commitType: "infiniteMessageScroll",
    storeKey: "messages",
    loadingKey: "messagesLoading",
    params
  });

const pushMessage = (context, message) =>
  context.commit("PUSH_MESSAGE", message);

const connectSocket = (context, params) =>
  restApiDispatcher(context, {
    resource: Chat,
    action: "connectSocket",
    commitType: "enable",
    storeKey: "connect",
    loadingKey: "connectLoading",
    params
  });

const blockUser = (context, params) =>
  restApiDispatcher(context, {
    resource: Chat,
    action: "blockUser",
    storeKey: "blockedUser",
    loadingKey: "blockedUserLoading",
    message: `${params.receiverName} has been blocked`,
    params
  });

const unblockUser = (context, params) =>
  restApiDispatcher(context, {
    resource: Chat,
    action: "unblockUser",
    storeKey: "unblockedUser",
    loadingKey: "unblockedUserLoading",
    message: `${params.receiverName} has been enabled`,
    params
  });

const ignoreUser = (context, params) =>
  restApiDispatcher(context, {
    resource: Chat,
    action: "ignoreUser",
    storeKey: "ignoredUser",
    loadingKey: "ignoredUserLoading",
    message: params.message,
    params
  });

const saveUser = (context, params) =>
  restApiDispatcher(context, {
    resource: Chat,
    action: "saveUser",
    storeKey: "savedUser",
    loadingKey: "savedUserLoading",
    message: `${params.receiverName} has been saved`,
    params
  });

const searchMessages = (context, params) =>
  restApiDispatcher(context, {
    resource: Message,
    action: "index",
    commitType: "indexUnwrapped",
    storeKey: "searchedMessages",
    loadingKey: "searchedMessagesLoading",
    params
  });

const getMessagePage = (context, params) =>
  restApiDispatcher(context, {
    resource: Message,
    action: "getPage",
    commitType: "messagePageShow",
    storeKey: "currentPage",
    loadingKey: "messagePageLoading",
    params
  });

const deleteMessages = (context, params) =>
  restApiDispatcher(context, {
    resource: Chat,
    action: "delete",
    commitType: "delete",
    message: "The conversation has been deleted",
    params
  });

const getSenderProfile = (context, params) =>
  restApiDispatcher(context, {
    resource: Chat,
    action: "getProfile",
    commitType: "show",
    storeKey: "senderProfile",
    loadingKey: "senderProfileLoading",
    params
  });

const deleteMultipleConversations = (context, params) =>
  restApiDispatcher(context, {
    resource: Chat,
    action: "deleteMultipleConversations",
    commitType: "show",
    message: "The conversations have been deleted.",
    params
  });

const unshiftContactList = (context, params) => context.commit("UNSHIFT_CONTACT_LIST", params);

const setBlockedToTrue = (context, conversation) =>
  context.commit("SET_BLOCKED_TO_TRUE", conversation);

const setBlockedToFalse = (context, conversation) =>
  context.commit("SET_BLOCKED_TO_FALSE", conversation);

const setIgnoredToTrue = (context, conversation) =>
  context.commit("SET_IGNORED_TO_TRUE", conversation);

const setIgnoredToFalse = (context, conversation) =>
  context.commit("SET_IGNORED_TO_FALSE", conversation);

const setSavedToTrue = (context, conversation) =>
  context.commit("SET_SAVED_TO_TRUE", conversation);

const setSavedToFalse = (context, conversation) =>
  context.commit("SET_SAVED_TO_FALSE", conversation);

const increaseCurrentMessagePage = context =>
  context.commit("INCREASE_CURRENT_MESSAGE_PAGE");

const decreaseCurrentMessagePage = context =>
  context.commit("DECREASE_CURRENT_MESSAGE_PAGE");

const setPageHistory = (context, history) =>
  context.commit("SET_PAGE_HISTORY", history);

const pushPageHistory = (context, data) =>
  context.commit("PUSH_PAGE_HISTORY", data);

const emptyMessages = context => context.commit("EMPTY_MESSAGES");

const deleteContactLocally = (context, contact) =>
  context.commit("DELETE_CONTACT_LOCALLY", contact);

const deleteContactById = (context, contactId) =>
  context.commit("DELETE_CONTACT_BY_ID", contactId);

const setReadToTrue = (context, conversation) =>
  context.commit("SET_READ_TO_TRUE", conversation);

const setReadToFalse = (context, message) =>
  context.commit("SET_READ_TO_FALSE", message);

const clearSearchedMessages = context =>
  context.commit("CLEAR_SEARCHED_MESSAGES");

const increaseContactListPage = context =>
  context.commit("INCREASE_CONTACT_LIST_PAGE");

const setContactListPage = (context, pageNumber) =>
  context.commit("SET_CONTACT_LIST_PAGE", pageNumber);

const clearContactList = context => context.commit("CLEAR_CONTACT_LIST");

const updateContact = (context, contact) =>
  context.commit("UPDATE_CONTACT", contact);

const setReceiverProfile = (context, profile) =>
  context.commit("SET_RECEIVER_PROFILE", profile);

const setNotificationCount = (context, total) =>
  context.commit("SET_NOTIFICATION_COUNT", total);

const decreaseNotificationCount = context =>
  context.commit("DECREASE_NOTIFICATION_COUNT");

const deleteReceiverProfile = context =>
  context.commit("DELETE_RECEIVER_PROFILE");

const conditionallySpliceContact = (context, contact) =>
  context.commit("CONDITIONALLY_SPLICE_CONTACT", contact);

const resetStore = context => context.commit("RESET_STORE");

const toggleUserOnlineOffline = (context, params) =>
  context.commit("TOGGLE_USER_ONLINE_OFFLINE", params);

export default {
  getContactList,
  getMessages,
  connectSocket,
  pushMessage,
  unshiftContactList,
  blockUser,
  unblockUser,
  setBlockedToTrue,
  setBlockedToFalse,
  ignoreUser,
  setIgnoredToTrue,
  setIgnoredToFalse,
  searchMessages,
  getMessagePage,
  increaseCurrentMessagePage,
  decreaseCurrentMessagePage,
  setPageHistory,
  pushPageHistory,
  deleteMessages,
  emptyMessages,
  deleteContactLocally,
  setReadToTrue,
  clearSearchedMessages,
  setReadToFalse,
  getSenderProfile,
  deleteMultipleConversations,
  increaseContactListPage,
  setContactListPage,
  clearContactList,
  saveUser,
  setSavedToTrue,
  setSavedToFalse,
  deleteContactById,
  updateContact,
  setReceiverProfile,
  setNotificationCount,
  decreaseNotificationCount,
  deleteReceiverProfile,
  conditionallySpliceContact,
  resetStore,
  toggleUserOnlineOffline
};
